import Environment from './environment';
import HwpTvApi from './hwpTvApi';
import { getLogger } from './logging/logger';
import { addReadyPromise } from './util/utilities';

const logger = getLogger('HwpTvAnalytics');

let arcade = '';

class Analytics {
	getTagId() {
		if (!Environment.isProd()) {
			return 'G-M0ZM4M2Y7N';
		}

		return 'G-FG9211M6VF';
	}

	constructor() {
		logger.log('[constructor]');
		addReadyPromise(this);

		// Add gtag script and wait for load
		const script = document.createElement('script');
		script.async = true;
		script.src = `https://www.googletagmanager.com/gtag/js?id=${this.getTagId()}`;
		script.addEventListener('load', this.onGtagLoaded.bind(this));
		script.addEventListener('error', this.onReadyReject);

		document.head.appendChild(script);
	}

	onGtagLoaded() {
		logger.log(`[${this.onGtagLoaded.name}]`);

		window.dataLayer = window.dataLayer || [];
		function gtag() {
			// eslint-disable-next-line prefer-rest-params
			window.dataLayer.push(arguments);
		}
		window.gtag = gtag;
		this.gtag = gtag;

		const params = new URLSearchParams(window.location.search);

		gtag('js', new Date());
		gtag('config', this.getTagId(), {
			send_page_view: false,
			campaign_name: params.get('utm_campaign'),
			campaign_source: params.get('utm_source'),
			campaign_medium: params.get('utm_medium'),
		});

		this.onReadyResolve();
	}

	setUserId(userId) {
		logger.log(`[${this.setUserId.name}]`, { userId });

		this.gtag('config', this.getTagId(), { user_id: userId });
	}

	setArcade(newArcade) {
		logger.log(`[${this.setArcade.name}]`, { newArcade });

		arcade = newArcade;
	}

	/**
	 * Logs analytic event to GA4 analytic system
	 * @param {String} eventName The name of the event
	 * @param {Object} [eventData] Any data associated with the event. ex {category, action, label, value}
	 */
	sendEvent(eventName, eventData = {}) {
		logger.log(`[${this.sendEvent.name}]`, { eventName, eventData });

		if (this.gtag) {
			this.gtag('event', eventName, { arcade, ...eventData });
		} else {
			logger.warn('Missing gtag function for Google Analytics');
		}

		return HwpTvApi.logEvent(arcade, eventName, eventData);
	}
}

export default new Analytics();
